// extracted by mini-css-extract-plugin
module.exports = {"edit-notes-wrapper":"EditNotes_edit-notes-wrapper__1S3pF"};